import gql from "graphql-tag";

export default gql`
mutation toggleSidebar($display: Boolean!) {
    toggleSidebar(display: $display) @client {
        display
    }
}`;



// WEBPACK FOOTER //
// ./src/mutations/toggleSidebar.ts